export default __webpack_public_path__ + "static/media/elta-black.91d7a3fd.png";